export default 0.25
